import { injectable } from 'inversify';
import { ViewStateService } from '../../../state/reduxViewServices/view.service';
import {
  AddNewPlayerViewState,
  ViewStates,
} from '../../../state/reduxViewServices/view.slice';

@injectable()
export class AddNewPlayerView extends ViewStateService<AddNewPlayerViewState> {
  constructor() {
    super(ViewStates.addPlayer);
  }

  usePendingPlayerCreationConneqtId = () => {
    return !!this.useViewStateSelector().pendingConneqtId;
  };

  usePendingPlayerCreationClues = () => {
    return this.useViewStateSelector().playerClues;
  };
}
